export const HIGH_RISE_SALES_MODULE_NAME = "high-rise-sales";
